import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
// import theme from '../../styles/GlobalTheme/schema.json';
// import { defaultStyle } from '../../styles/GlobalTheme/GlobalStyles';
import px2vw from '../../utils/px2vw';

export const NavDetails = styled(motion.div)`
    display: flex;
    background: #FFFFFF;
    justify-content: ${props => props.justifyContent || 'space-between'};
    padding: 0 ${px2vw(200)} 0 ${px2vw(200)};
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    padding-bottom: 46px;

    @media screen and (max-width: 768px) {
        font-size: 24px;
        margin-left: 0px;
        padding-left: 10px;
        padding-right: 20px;
        width: 100%;
        justify-content: space-around;
    }

    @media screen and (max-width: 425px) {
        font-size: 24px;
        margin-left: 0px;
    }

    @media screen and (max-width: 320px) {
        font-size: 20px;
        margin-left: 0px;
    }
`;

export const NavList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const NavIcon = styled.div`
    margin-top: 59.96px;
`;

export const NavItemsTitle = styled.h3`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    @media screen and (max-width: 768px) {
        font-size: 16px;
        margin-left: 0px;
        width: 100%;
    }
`;

export const NavItem = styled(Link)`
    margin-top: 0px;
    margin-bottom: 23px;
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #0A2540;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        color: black;
        text-decoration: underline;
    }

    @media screen and (max-width: 768px) {
        font-size: 12px;
        margin-left: 0px;
        width: 100%;
    }
`;

export const NavMobile = styled.div`
    /* padding: 5px 10px 5px 10px; */
    display: flex;
    background: #FFFFFF;
    flex-direction: column;
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.1);
    justify-content: flex-start;
`;

export const NavMobileItem = styled.div`
    display: flex;
    justify-self: flex-start;
    padding: 10px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.085);
    cursor: pointer;
    align-items: center;
    flex-direction: row;
`;

export const NavMobileLink = styled(Link)`
    margin-top: 0px;
    /* margin-bottom: 23px; */
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #0A2540;
    cursor: pointer;
    text-decoration: none;
    justify-content: center;

    &:hover {
        color: black;
        /* text-decoration: underline; */
    }

    @media screen and (max-width: 768px) {
        font-size: 12px;
        margin-left: 0px;
        width: 100%;
    }
`;

export const ContactTitle = styled.h3`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
`;

export const ContactText = styled.h3`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    color: #0A2540;
    margin-bottom: 115px;
`;